import React, { Component } from 'react';
import { Divider, Grid, Segment } from 'semantic-ui-react'
import AccountsList from "../AccountsList/index";
import RemindersList from "../RemindersList/index";
import DepositsList from "../DepositsList/index";
// import VideosList from "../VideosList/index";
import AutoplayVideoJS from "../AutoplayVideoJS/index";

export default class Overview extends Component {

    componentDidMount(){
        this.props.updatenav("overview");
    }

    render() {
        return (
            <div>
                <Divider hidden />
                <AutoplayVideoJS />
                <Grid stackable>
                    <Grid.Column width={6} only='computer' className='grid-padding'>
                        <Segment>
                            <AccountsList />                            
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={10} only='computer' className='grid-padding'>
                        <Segment>
                            <RemindersList />
                        </Segment>
                        <Segment>
                            <DepositsList />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={16} only='tablet mobile' className='grid-padding'>
                        <Segment>
                            <RemindersList />
                        </Segment>
                        <Segment>
                            <DepositsList />
                        </Segment>
                        <Segment>
                            <AccountsList />
                        </Segment>
                    </Grid.Column>
                </Grid>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/Overview/index.js